export default __webpack_public_path__ + "7c9436e4ff9d30239b784e84fbce7824.png";